import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection, toggleUploadModal } from "../../../actions";
import Intro from "./Intro";
import Dialog from "../../Dialog";
import UserArt from "../../UserArt";
import "./UploadTools.css";
import localStorageWrapper from "../../../services/localStorageWrapper";

class UploadTools extends React.Component {
  state = {
    showDialog: false,
  };

  componentDidMount() {
    // Set 'Upload' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Upload" });

    this.dialog = {
      title: "Designer's Tip",
      message: "Upload your own art for a truly unique product.",
      topPosition: 110,
      leftPosition: 50,
      origin: "topleft",
    };

    // Expiration for local storage
    const now = Date.now(),
      expires = 60 * 60 * 1000 * 24;

    if (
      !this.state.showDialog &&
      !localStorageWrapper.getItem("fypUploadDialogShown")
    ) {
      // Set local storage for 24 hours to remember that the tips have been shown
      localStorageWrapper.setItem("fypUploadDialogShown", true);
      localStorageWrapper.setItem("fypUploadDialogShownTimestamp", now);

      this.setState({
        showDialog: true,
      });
    }

    // Delete local storage after 24 hours
    if (
      now - localStorageWrapper.getItem("fypUploadDialogShownTimestamp") >
      expires
    ) {
      localStorageWrapper.removeItem("fypUploadDialogShown");
      localStorageWrapper.removeItem("fypUploadDialogShownTimestamp");
    }
  }

  onShowUploadModal = () => {
    this.props.toggleUploadModal({
      isVisible: true,
      type: "art",
    });
  };

  handleHideDialog = () => {
    this.setState({
      showDialog: false,
    });
  };

  render() {
    const userArtArray = this.props.upload.user_art.entities;
    let countUserArt = 0;

    if (userArtArray.length) {
      countUserArt = userArtArray.filter((obj) => {
        return obj.field_type === "art";
      }).length;
    }

    return (
      <div className="tools-container tools-container--upload">
        <Intro onShowUploadModal={this.onShowUploadModal} />
        {/*<Bleed />*/}

        {countUserArt > 0 && (
          <div>
            {this.state.showDialog && this.dialog && (
              <Dialog
                dialog={this.dialog}
                onHideDialog={this.handleHideDialog}
              />
            )}
            <h4 className="tool__header">Your Art</h4>
            <div className="drag-elements__instructions">
              <b className="upload-graphics-copy">
                Click on the art to place on product
              </b>
            </div>
            <UserArt imageType="art" />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    upload: state.upload,
    user_art: state.upload.user_art.entities,
    productOption: state.productOption,
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection,
      toggleUploadModal,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadTools);
